<script>
import {useCompaniesStore} from "@/stores/companies.js";
import {mapStores} from "pinia";
import FilterCheckbox from "@/Forms/Filters/FilterCheckbox.vue";

export default {
  name: "FilterCompaniesTab",
  inheritAttrs: false,
  components: {FilterCheckbox},
  computed: {
    ...mapStores(useCompaniesStore),
  },
  mounted() {
    console.log(this.$options.name);
    this.companiesStore.indexCompanyOptions();
  },
}
</script>

<template>
  <p class="font-bold text-xl mb-4">Vehicle Manufacturers</p>
  <div class="card flex flex-wrap justify-content-center gap-3">
    <FilterCheckbox
        v-for="company in companiesStore.getCompanyOptions.filter(c => !!c.vehicle_manufacturer)"
        v-bind="$attrs"
        :value="company.id"
        :label="company.name"
    />
  </div>
</template>

<style scoped>

</style>